import { useSelector } from 'react-redux'
import { profileView } from './storage'

export function useProfile() {
  return useSelector(profileView)
}
